module.exports = __webpack_public_path__ + "img/kei_new_sam.db434f1a.gif";